import styled from 'styled-components';

const StyledMarquee = styled.div`
  position: relative;
  width: 100%;
  text-align: left;
  overflow: hidden;
  padding-top: ${props => props.theme.components_spacing_desk.xxlarge}px;
  .marquee--wrap{
    position: relative;
    width: 100%;
    display: flex;
  }
  .marquee--slider{
    position: relative;
    display: flex;
    flex-direction: row;
    z-index: 2;
    animation: slideMarquee 40s infinite linear;
  }
  h5{
    display: inline-block;
    white-space: nowrap;
    color: ${ props => props.theme.colors.green_secondary};
    line-height: 130% !important;
    padding-right: 20px;
  }
  @media screen and (max-width: 1023px){
    padding-top: ${props => props.theme.components_spacing_tablet.xxlarge}px;
  }
  @media screen and (max-width: 767px){
    padding-top: ${props => props.theme.components_spacing_tablet.xxlarge}px;
  }
  @keyframes slideMarquee {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-100%);
    }
  }
`;

export {
  StyledMarquee,
};

